import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { LogIn, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function WebsiteUnavailable({ data }) {
  const navigate = useNavigate();
  const primaryColor = data?.primary_color || '#1e3a8a';
  const schoolName = data?.school_name || 'School';
  const erpEnabled = data?.erp_enabled !== false;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8fafc',
        p: 3,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 5,
            textAlign: 'center',
            backgroundColor: '#ffffff',
            border: '1px solid #e2e8f0',
            boxShadow: '0 20px 40px rgba(0,0,0,0.06)',
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: '#fef3c7',
              color: '#d97706',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3,
            }}
          >
            <AlertTriangle size={40} />
          </Box>

          <Typography variant="h4" fontWeight={800} color="#0f172a" sx={{ mb: 1.5 }}>
            Website Currently Unavailable
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
            The public website for <strong>{schoolName}</strong> is currently undergoing maintenance or is not enabled. Please check back later.
          </Typography>

          {erpEnabled && (
            <Button
              variant="contained"
              size="large"
              startIcon={<LogIn size={20} />}
              onClick={() => navigate('/ERP')}
              sx={{
                backgroundColor: primaryColor,
                py: 1.2,
                px: 4,
                borderRadius: 2.5,
                fontWeight: 700,
                textTransform: 'none',
              }}
            >
              Access School ERP Login
            </Button>
          )}
        </Paper>
      </Container>
    </Box>
  );
}
